export async function comandoAr(local, acao) {
  console.log(`Acionamento do ar ${local} com a ação ${acao}`)
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/comandoar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ local, acao })
        });
    
        const data = await response.json(); // Aguarda a resposta e converte para JSON
        console.log(data); // Exibe a resposta no console
      } catch (error) {
        console.error('Erro:', error); // Captura e exibe erros
      }
    }